export const formatPhoneNumber = (phoneNumber) => {
  const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');

  if (cleanedPhoneNumber.length === 11) {
    return `+1 (${cleanedPhoneNumber.substring(1, 4)}) ${cleanedPhoneNumber.substring(
      4,
      7,
    )}-${cleanedPhoneNumber.substring(7)}`;
  } else if (cleanedPhoneNumber.length === 10) {
    return `(${cleanedPhoneNumber.substring(0, 3)}) ${cleanedPhoneNumber.substring(
      3,
      6,
    )}-${cleanedPhoneNumber.substring(6)}`;
  } else {
    return phoneNumber;
  }
};

export const formatPhoneNumberWithoutPlusOne = (phoneNumber) => {
  const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');

  if (cleanedPhoneNumber.length === 11) {
    // Remove country code, format as (XXX) XXX-XXXX
    return `(${cleanedPhoneNumber.substring(1, 4)}) ${cleanedPhoneNumber.substring(4, 7)}-${cleanedPhoneNumber.substring(7)}`;
  } else if (cleanedPhoneNumber.length === 10) {
    return `(${cleanedPhoneNumber.substring(0, 3)}) ${cleanedPhoneNumber.substring(3, 6)}-${cleanedPhoneNumber.substring(6)}`;
  } else {
    return phoneNumber;
  }
};

export const updatePhoneNumberElementsHref = (phoneNumber) => {
  const changeNumberElements = document.querySelectorAll('.change-number-without-text');

  changeNumberElements.forEach((element) => {
    if (element.tagName === 'A') {
      (element as HTMLAnchorElement).href = 'tel:' + phoneNumber;
    }
  });
};

export const updatePhoneNumberElements = (phoneNumber, formattedPhoneNumber) => {
  const changeNumberElements = document.querySelectorAll('.change-number, .change_phone_without_plus_one');

  changeNumberElements.forEach((element) => {
    let textDiv = element.querySelector('[data-phone="true"]');
    if (!textDiv) {
      textDiv = Array.from(element.children).find(
        (child) => child.tagName === 'DIV' && child.textContent && child.textContent.trim().match(/\+?\d/),
      );
    }
    let finalFormatted = formattedPhoneNumber;

    if (element.classList.contains('change_phone_without_plus_one')) {
      finalFormatted = formatPhoneNumberWithoutPlusOne(phoneNumber)}

    if (textDiv) {
      textDiv.textContent = finalFormatted;
    } else {
      element.textContent = finalFormatted;
    }
    if (element.tagName === 'A') {
      (element as HTMLAnchorElement).href = 'tel:' + phoneNumber;
    }
  });
};

export const autofillUtmFields = () => {
  const urlParams = new URLSearchParams(window.location.search || '');
  const utmParams = ['utm_source', 'utm_medium', 'utm_term', 'utm_content', 'utm_campaign'];

  utmParams.forEach(function (param) {
    const paramValue = urlParams.get(param);
    const utmField = document.querySelector(`input[name='${param}']`);
    if (paramValue && utmField) {
      (utmField as HTMLInputElement).value = paramValue.trim();
    }
  });
};

export function generateIdempotencyKey(): string {
  const c = globalThis.crypto;

  // use built-in secure UUID if available
  if (c?.randomUUID) return c.randomUUID();

  // fallback: generate UUID v4 using crypto.getRandomValues (still secure)
  // avoids Math.random() since it's not cryptographically safe
  if (c?.getRandomValues) {
    const bytes = new Uint8Array(16);
    c.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }

  // no secure RNG available → fail instead of generating a weak key
  throw new Error('Secure RNG not available for idempotency key');
}

export const pushDataLayerEvent = (event: string, data: Record<string, unknown> = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
};
